import { TUseMyBookingRow } from "./MyBookingRow";

export const TtIcon = ({ currentState }: TUseMyBookingRow) => {
  const productTypes = [
    {
      urlIcon: "../assets/images/icons/pass.svg",
      productType: "PASS",
    },
    {
      urlIcon: "../assets/images/icons/ticket-old.svg",
      productType: "TICKET",
    },
    {
      urlIcon: "../assets/images/icons/air-balloon-old.svg",
      productType: "TOUR",
    },
    {
      urlIcon: "../assets/images/icons/watch-old.svg",
      productType: "MUSICAL",
    },
    {
      urlIcon: "../assets/images/icons/sim-card-old.svg",
      productType: "SIM",
    },
  ];
  const icon = productTypes.find(
    (xx) => xx.productType === currentState?.product?.productType,
  )?.urlIcon;

  return icon ? <img className="size-6" src={icon} alt="" /> : null;
};
